import TabsContent from "@/components/ui/Tabs/TabsContent";
import { PartComponent } from "@/types/design";
import { partMenuItems } from "../PartMenu";
import PartMove from "../Setting/PartMove";
import Part from "./Part";
import styles from "./PartList.module.scss";
import { partsStore } from "@/store/partsStore";

type Props = {
	showPartMove: Boolean;
};

/**
 * パーツ一覧 コンポーネント
 * @returns {JSX.Element} パーツ一覧 コンポーネント
 */
export default function PartList(props: Props) {
	const { showPartMove } = props;
	const { parts } = partsStore();

	return (
		<div className={styles.partsListContainer}>
			{/* {showPalette && <Palette selectingPart={selectingPart} />} */}

			{showPartMove && <PartMove />}

			{!showPartMove &&
				partMenuItems.map((item) => {
					const partName = item.name;
					const targetParts = parts[partName] || [];

					return (
						<TabsContent key={partName} value={partName}>
							<div className={styles.partList}>
								{targetParts?.map(
									(
										partComponent: PartComponent,
										index: number,
									) => (
										<Part
											key={index}
											partComponent={partComponent}
											partName={partName}
										/>
									),
								)}
							</div>
						</TabsContent>
					);
				})}
		</div>
	);
}
